import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AwbService {
    private basePath = environment.interop.basePath;

    public downloadCSVUrl = this.basePath + environment.interop.indoc.awb.downloadCSV;
    public downloadPDFUrl = this.basePath + environment.interop.indoc.awb.downloadPDF;
    public downloadPDFAwbUrl = this.basePath + environment.interop.indoc.awb.downloadPDFAwb;
    private deleteAwbUrl = this.basePath + environment.interop.indoc.awb.deleteAwb;
    private deleteAwbPostaUrl = this.basePath + environment.interop.indoc.awb.deleteAwbPosta;

    constructor(private http: HttpClient) { }

    deleteAwb(id: number) {
        return this.http.delete(this.deleteAwbUrl + id);
    }

    deleteAwbPosta(id: number) {
        return this.http.delete(this.deleteAwbPostaUrl + id);
    }
}
